<template>
  <div id="root">
    <main>
      <slot></slot>
    </main>
  </div>
</template>
<script>
export default {
  mounted() {
    document.body.classList.add('background')
  },
  beforeDestroy() {
    document.body.classList.remove('background')
  }
}
</script>
